// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1WGiE","right":"styles_right__3wOES"};